// frontend/src/components/userDetails/tabs/SettingsTab.jsx
import React, { useState, useEffect } from "react";
import { Form, Button, Alert, Spinner } from "react-bootstrap";
import axiosClient from "../../../api/axiosClient";

const SettingsTab = ({ userId }) => {
  const [settings, setSettings] = useState({
    enableApi: false,
    enableManualReports: false,
  });

  const [message, setMessage] = useState({ text: "", type: "" });
  const [loading, setLoading] = useState(false);

  const numericUserId = Number(userId);

// debug
// console.log("numericUserId:", numericUserId);

  // Load settings
  // useEffect(() => {
  //   const loadSettings = async () => {
  //     if (!(numericUserId > 0)) return;
  //     try {
  //       const res = await axiosClient.get(`/user-settings/${numericUserId}`);
  //       console.log("GET user-settings response:", res.data);
  //       setSettings({
  //         enableApi: !!res.data.enable_api,
  //         enableManualReports: !!res.data.enable_manual_reports,
  //       });
  //     } catch (err) {
  //       console.error("Failed to load settings:", err);
  //     }
  //   };
  //   loadSettings();
  // }, [numericUserId]);

  // quick test
  useEffect(() => {
  const loadSettings = async () => {
    if (!(numericUserId > 0)) return;

    try {
      console.log("Fetching settings...");
      const res = await axiosClient.get(`/user-settings/${numericUserId}`);
      console.log("GET user-settings response:", res.data);
      setSettings({
        enableApi: !!res.data.enable_api,
        enableManualReports: !!res.data.enable_manual_reports,
      });
    } catch (err) {
      console.error("Failed to load settings:", err);
    }
  };
  loadSettings();
}, [numericUserId]);


 const handleToggle = (e) => {
  const { name, checked } = e.target;

  setSettings((prev) => {
    let updated = { ...prev, [name]: checked };

    // MUTUAL EXCLUSIVITY LOGIC
    if (name === "enableApi" && checked) {
      updated.enableManualReports = false;
    }
    if (name === "enableManualReports" && checked) {
      updated.enableApi = false;
    }

    return updated;
  });
};


  const saveSettings = async () => {
    if (!(numericUserId > 0)) return;

    setLoading(true);
    try {
      const res = await axiosClient.put(`/user-settings/${numericUserId}`, settings);
      setMessage({ text: res.data.message || "Settings saved", type: "success" });
    } catch (err) {
      console.error("Save Settings Error:", err);
      setMessage({
        text: err.response?.data?.message || "Failed to save settings",
        type: "danger",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-3">
      <h5>Settings</h5>

      {message.text && (
        <Alert
          variant={message.type}
          onClose={() => setMessage({ text: "", type: "" })}
          dismissible
        >
          {message.text}
        </Alert>
      )}

      <Form.Group className="mb-3">
        <Form.Check
          type="checkbox"
          name="enableApi"
          label="Enable API Service"
          checked={settings.enableApi}
          onChange={handleToggle}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Check
          type="checkbox"
          name="enableManualReports"
          label="Enable Manual Report Upload"
          checked={settings.enableManualReports}
          onChange={handleToggle}
        />
      </Form.Group>

      <Button onClick={saveSettings} disabled={loading}>
        {loading ? <Spinner animation="border" size="sm" className="me-2" /> : "Save Settings"}
      </Button>
    </div>
  );
};

export default SettingsTab;
